import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 添加参数 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_input_group, { compact: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramsArrays, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            style: {"display":"flex","align-items":"center","margin-bottom":"10px"}
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_input, {
                value: item.key,
                "onUpdate:value": ($event: any) => ((item.key) = $event),
                "addon-before": "参数名称",
                style: {"width":"200px"},
                placeholder: "key"
              }, null, 8, ["value", "onUpdate:value"]),
              _createVNode(_component_a_input, {
                value: item.value,
                "onUpdate:value": ($event: any) => ((item.value) = $event),
                "addon-before": "参数值",
                style: {"width":"200px"},
                placeholder: "value"
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createVNode(_component_MinusCircleOutlined, {
              onClick: ($event: any) => (_ctx.removeParams(item.id)),
              style: {"margin-left":"10px","font-size":"20px"}
            }, null, 8, ["onClick"])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_a_button, {
      type: "dashed",
      block: "",
      onClick: _ctx.addParams,
      style: {"width":"400px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PlusOutlined),
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}